module.exports = __webpack_public_path__ + "static/hut-doodle-05dbc5a8969140d20accf687a6bb5761.jpg";